import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import User from 'src/components/Dashboard/Views/Pages/BGUserProfile.vue'
import Question from 'src/components/Dashboard/Views/Pages/BGQuestion.vue'
import BGBetgame from 'src/components/Dashboard/Views/Pages/BGBetgame'
import BetgameStatistics from 'src/components/Dashboard/Views/Pages/BetgameStatistics'

// Dashboard pages
// import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
// import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'
/*
// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'

import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'
import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
*/
import PaginatedTables from 'src/components/Dashboard/Views/Tables/BGPaginatedTables.vue'
import UsersPaginatedTables from 'src/components/Dashboard/Views/Tables/UsersPaginatedTables.vue'
import QuestionsPaginatedTables from 'src/components/Dashboard/Views/Tables/QuestionsPaginatedTables.vue'
import BGBetgameSettings from '../components/Dashboard/Views/Pages/BGBetgameSettings'
import BGBetgameSlides from '../components/Dashboard/Views/Pages/BGBetgameSlides'
import BGBetgameAds from '../components/Dashboard/Views/Pages/BGBetgameAds'
import BGBetgameRules from '../components/Dashboard/Views/Pages/BGBetgameRules'
import BGBetgameConditions from '../components/Dashboard/Views/Pages/BGBetgameConditions'
import BGBetgameDesign from '../components/Dashboard/Views/Pages/BGBetgameDesign'
import BGBetgameAdconsent from '../components/Dashboard/Views/Pages/BGBetgameAdconsent.vue'
import BGBetgamePrivacy from '../components/Dashboard/Views/Pages/BGBetgamePrivacy.vue'

/*
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'
*/
/*
let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}
*/

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let logoutPage = {
  path: '/logout',
  name: 'Logout',
  component: Login
}

/*
let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}


let matchdayRankingsPage = {
  path: '/matchdayrankings',
  name: 'Spieltagssieger',
  component: PaginatedTables
}
*/
const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/betgamedata',
    children: [
      {
        path: 'betgamedata',
        name: 'Tippspiel',
        component: BGBetgame,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgamedesign',
        name: 'Design',
        component: BGBetgameDesign,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgamesettings',
        name: 'Wertung',
        component: BGBetgameSettings,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgamerules',
        name: 'Spielregeln',
        component: BGBetgameRules,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgameconditions',
        name: 'Nutzungsbedingungen',
        component: BGBetgameConditions,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgameprivacy',
        name: 'Datenschutzerklärung',
        component: BGBetgamePrivacy,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgameadconsent',
        name: 'Werbevereinbarung',
        component: BGBetgameAdconsent,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgameslides',
        name: 'Slides',
        component: BGBetgameSlides,
        meta: { requiresAuth: true }
      },
      {
        path: 'betgameads',
        name: 'Banner',
        component: BGBetgameAds,
        meta: { requiresAuth: true }
      },
      {
        path: 'matchdayrankings',
        name: 'Spieltagssieger',
        component: PaginatedTables,
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'Benutzer',
        component: UsersPaginatedTables,
        meta: { requiresAuth: true }
      },
      {
        path: 'questions',
        name: 'Sonderfragen',
        component: QuestionsPaginatedTables,
        meta: { requiresAuth: true }
      },
      {
        path: 'user/:id',
        name: 'Profil',
        component: User,
        meta: { requiresAuth: true }
      },
      {
        path: 'question/:id',
        name: 'Sonderfrage',
        component: Question,
        meta: { requiresAuth: true }
      },
      {
        path: 'statistics',
        name: 'Statistiken',
        component: BetgameStatistics,
        meta: { requiresAuth: true }
      }
    ]
  },
  loginPage,
  logoutPage,
  // matchdayRankingsPage,
/*
componentsMenu,
formsMenu,
tablesMenu,
mapsMenu,
pagesMenu,
registerPage,
lockPage,
{
  path: '/admin',
  component: DashboardLayout,
  redirect: '/admin/overview',
  children: [
    {
      path: 'overview',
      name: 'Overview',
      component: Overview
    },
    {
      path: 'stats',
      name: 'Stats',
      component: Stats
    }
  ]
},
 */
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js